import { type FC, type ReactElement, useEffect, useState } from "react"
import { BrowserRouter, Switch, Route } from "react-router-dom"

import { withHtmlHead } from "~/shared/ui/hocs"
import { Loading } from "~/shared/ui"

const appModules = import.meta.glob("../../apps/a/*/App.jsx") as Record<
	string,
	() => Promise<{ default: FC }>
>
const appMetadata = import.meta.glob("../../apps/a/*/metadata.json") as Record<
	string,
	() => Promise<{ default: any }>
>

type OldApp = {
	appName: string
	render: () => ReactElement
}

export const apps = Object.entries(appModules)
	.map(([appPath, loadApp]) => {
		const parsedAppPath = /^\.\.\/\.\.\/apps\/a\/([^/]+)\//.exec(appPath)

		if (!parsedAppPath || parsedAppPath.length < 2) return undefined
		const appName = parsedAppPath[1]

		return {
			appName,
			render: () => (
				<OldAppContainer
					appName={appName}
					loadApp={loadApp}
					loadMetadata={
						appMetadata[`../../apps/a/${appName}/metadata.json`]
					}
				/>
			),
		}
	})
	.filter(Boolean) as OldApp[]

function OldAppContainer({ appName, loadMetadata, loadApp }) {
	const [app, setApp] = useState<{ App: FC } | null>(null)

	useEffect(() => {
		;(async () => {
			const { default: App } = await loadApp()
			const { default: metadata } = await loadMetadata()

			setApp({
				App: withHtmlHead(metadata)(App),
			})
		})()
	}, [appName, loadMetadata, loadApp])

	if (!app)
		return (
			<div className="w-[100vw] h-[100vh] flex items-center justify-center">
				<Loading loading delay={0.5} />
			</div>
		)

	return <app.App />
}

/**
 * Маршрутизатор приложений из предыдущей версии ЭИОС
 */
export function OldAppsRouter() {
	return (
		<BrowserRouter>
			<Switch>
				{apps.map((app) => (
					<Route
						key={app.appName}
						path={"/a/" + app.appName}
						render={app.render}
					/>
				))}
			</Switch>
		</BrowserRouter>
	)
}
